import { css } from '@emotion/react';
import {
  ButtonComponent, ButtonStyle,
} from '~/_shared/baseComponents/buttons';
import { ModalComponent } from '~/_shared/components/modal/modal.component';
import { useTranslation } from '~/_shared/utils/hooks';
import type { ModalProps } from '~/modal/modalType.enum';

const contentStyle = css({
  padding: '8px 12px',
  display: 'flex',
  flexDirection: 'column',
});

export const DataLayerUpgradeModalComponent = ({
  isOpen,
  onClose,
  onOpenSupportChat,
}: ModalProps<{
  onOpenSupportChat: () => void;
}>) => {
  const [t] = useTranslation();

  return (
    <ModalComponent
      onClose={onClose}
      isOpen={isOpen}
      contentStyle={contentStyle}
      maxWidth={600}
      caption={t('Upgrade')}
    >
      {/* TODO Data-Layers: replace with actual upgrade modal content */}
      some contenet
      <ButtonComponent
        buttonStyle={ButtonStyle.Success}
        text={t('Live Chat')}
        onClick={onOpenSupportChat}
      />
    </ModalComponent>
  );
};
